/* LAYOUT FILES */
import { useLocation } from "react-router-dom";
import Header from "./header";
import Footer from "./footer";

const Layout = ({ children }) => {
  const { pathname } = useLocation();
  const hideChrome = pathname === "/";

  return (
    <>
      {!hideChrome && <Header />}
      <div className="main">{children}</div>
      {!hideChrome && <Footer />}
    </>
  );
};

export default Layout;
